/* ==========================================================================
   lbl-coffee-anatomy — interaktive Hotspots + Mobile-Bottom-Sheet-Stepper
   Desktop: Hover/Fokus auf Hotspot oder Chip → Detail im konstanten Panel.
   Mobile (<990px): Tap → Bottom-Sheet (Detail-Panel wird hinein verschoben),
   Stepper prev/next, Dots, Escape/Scrim schließen, Fokus-Management + -Falle.
   ========================================================================== */
(function () {
  'use strict';

  function setup(root) {
    var hots = Array.prototype.slice.call(root.querySelectorAll('.lbl-coffee-anat__hot'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('.lbl-coffee-anat__chip'));
    var names = Array.prototype.slice.call(root.querySelectorAll('.lbl-coffee-anat__name'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.lbl-coffee-anat__panel'));
    var detail = root.querySelector('[data-anat-detail]');
    if (!panels.length || !detail) return;

    // Signalisiert dem CSS, dass JS aktiv ist → Inline-Detail auf Mobile ausblendbar (Sheet übernimmt)
    root.classList.add('lbl-coffee-anat--js');

    var count = panels.length;
    var active = parseInt(root.getAttribute('data-default-index'), 10);
    if (isNaN(active) || active < 0 || active >= count) active = 0;

    var mq = window.matchMedia('(max-width: 989px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // --- Sheet-Gerüst (einmal aufgebaut, wiederverwendet) ---
    var detailHome = document.createComment('anat-detail-home');
    var sheetWrap = null, sheetBody = null, stepEl = null, dotsEl = null, closeBtn = null, lastTrigger = null;

    function buildSheet() {
      sheetWrap = document.createElement('div');
      sheetWrap.className = 'lbl-coffee-anat__sheet-wrap';
      sheetWrap.hidden = true;
      sheetWrap.innerHTML =
        '<button class="lbl-coffee-anat__scrim" type="button" aria-label="Schließen"></button>' +
        '<div class="lbl-coffee-anat__sheet" role="dialog" aria-modal="true">' +
          '<div class="lbl-coffee-anat__sheet-hd">' +
            '<span class="lbl-coffee-anat__sheet-step"></span>' +
            '<button class="lbl-coffee-anat__sheet-x" type="button" aria-label="Schließen">' +
              '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="lbl-coffee-anat__sheet-body"></div>' +
          '<div class="lbl-coffee-anat__sheet-nav">' +
            '<button class="navbtn prev" type="button" aria-label="Vorherige Komponente"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg></button>' +
            '<div class="lbl-coffee-anat__dots" aria-hidden="true"></div>' +
            '<button class="navbtn next" type="button" aria-label="Nächste Komponente"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button>' +
          '</div>' +
        '</div>';
      sheetBody = sheetWrap.querySelector('.lbl-coffee-anat__sheet-body');
      stepEl = sheetWrap.querySelector('.lbl-coffee-anat__sheet-step');
      dotsEl = sheetWrap.querySelector('.lbl-coffee-anat__dots');
      closeBtn = sheetWrap.querySelector('.lbl-coffee-anat__sheet-x');
      for (var i = 0; i < count; i++) {
        var d = document.createElement('span');
        d.className = 'd';
        dotsEl.appendChild(d);
      }
      sheetWrap.querySelector('.lbl-coffee-anat__scrim').addEventListener('click', closeSheet);
      closeBtn.addEventListener('click', closeSheet);
      sheetWrap.querySelector('.navbtn.prev').addEventListener('click', function () { step(-1); });
      sheetWrap.querySelector('.navbtn.next').addEventListener('click', function () { step(1); });
      root.appendChild(sheetWrap);
    }

    function setActive(i) {
      active = (i + count) % count;
      hots.forEach(function (h) {
        var on = parseInt(h.getAttribute('data-index'), 10) === active;
        h.classList.toggle('is-active', on);
        h.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      chips.forEach(function (c) {
        var on = parseInt(c.getAttribute('data-index'), 10) === active;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-selected', on ? 'true' : 'false');
        // aktiven Chip in der mobilen Swipe-Zeile in Sicht halten
        if (on && mq.matches && c.scrollIntoView) {
          c.scrollIntoView({ inline: 'center', block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
        }
      });
      names.forEach(function (nm) {
        var on = parseInt(nm.getAttribute('data-index'), 10) === active;
        nm.classList.toggle('is-active', on);
        nm.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.hidden = parseInt(p.getAttribute('data-index'), 10) !== active;
      });
      if (sheetWrap && !sheetWrap.hidden) {
        var pad2 = function (n) { return (n < 10 ? '0' : '') + n; };
        stepEl.textContent = pad2(active + 1) + ' / ' + pad2(count);
        Array.prototype.forEach.call(dotsEl.children, function (d, di) { d.classList.toggle('on', di === active); });
      }
    }

    function step(dir) { setActive(active + dir); }

    // --- Sheet öffnen/schließen (nur Mobile) ---
    function openSheet(trigger) {
      if (!sheetWrap) buildSheet();
      lastTrigger = trigger || null;
      // Detail-Panel-Box in den Sheet-Body verschieben
      detail.parentNode.insertBefore(detailHome, detail);
      sheetBody.appendChild(detail);
      sheetWrap.hidden = false;
      setActive(active); // step/dots aktualisieren
      document.addEventListener('keydown', onKey);
      // Slide-up + Scrim-Fade auf dem nächsten Frame triggern (sonst kein Übergang)
      if (reduce) { sheetWrap.classList.add('is-open'); closeBtn.focus(); }
      else { requestAnimationFrame(function () { sheetWrap.classList.add('is-open'); closeBtn.focus(); }); }
    }
    function finalizeClose() {
      if (sheetWrap.classList.contains('is-open')) return; // zwischenzeitlich wieder geöffnet
      sheetWrap.hidden = true;
      // Detail-Panel zurück an Originalposition
      if (detailHome.parentNode) detailHome.parentNode.insertBefore(detail, detailHome);
      if (detailHome.parentNode) detailHome.parentNode.removeChild(detailHome);
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    }
    function closeSheet() {
      if (!sheetWrap || sheetWrap.hidden) return;
      document.removeEventListener('keydown', onKey);
      sheetWrap.classList.remove('is-open');
      if (reduce) { finalizeClose(); return; }
      // nach der Slide-down-Animation aufräumen (transitionend + Timeout-Fallback)
      var sheetEl = sheetWrap.querySelector('.lbl-coffee-anat__sheet');
      var done = false;
      var onEnd = function (e) {
        if (e && e.target !== sheetEl) return;
        if (done) return;
        done = true;
        sheetEl.removeEventListener('transitionend', onEnd);
        finalizeClose();
      };
      sheetEl.addEventListener('transitionend', onEnd);
      setTimeout(onEnd, 420);
    }
    function onKey(e) {
      if (e.key === 'Escape') { closeSheet(); return; }
      if (e.key === 'Tab') {
        var f = sheetWrap.querySelectorAll('button');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    // --- Events ---
    function pick(i, trigger) {
      setActive(i);
      if (mq.matches) openSheet(trigger);
    }
    hots.forEach(function (h) {
      var i = parseInt(h.getAttribute('data-index'), 10);
      h.addEventListener('click', function () { pick(i, h); });
      h.addEventListener('mouseenter', function () { if (!mq.matches) setActive(i); });
    });
    chips.forEach(function (c) {
      var i = parseInt(c.getAttribute('data-index'), 10);
      c.addEventListener('click', function () { pick(i, c); });
      c.addEventListener('mouseenter', function () { if (!mq.matches) setActive(i); });
      c.addEventListener('focus', function () { if (!mq.matches) setActive(i); });
    });
    names.forEach(function (nm) {
      var i = parseInt(nm.getAttribute('data-index'), 10);
      nm.addEventListener('click', function () { pick(i, nm); });
      nm.addEventListener('mouseenter', function () { if (!mq.matches) setActive(i); });
      nm.addEventListener('focus', function () { if (!mq.matches) setActive(i); });
    });

    // Wechsel auf Desktop schließt ein offenes Sheet sauber
    var onMq = function () { if (!mq.matches) closeSheet(); };
    mq.addEventListener ? mq.addEventListener('change', onMq) : mq.addListener(onMq);

    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target === root || root.contains(e.target)) {
        mq.removeEventListener ? mq.removeEventListener('change', onMq) : mq.removeListener(onMq);
      }
    });

    setActive(active);
  }

  function init() {
    var roots = document.querySelectorAll('[data-lbl-anatomy]');
    Array.prototype.forEach.call(roots, setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
